import { Navigate, Outlet } from "react-router-dom";
import { canUseDashboard } from "../firebase/firebase";
import { useSession } from "../firebase/useSession";
import { Spinner } from "./ui/Spinner";

function RequireAuth() {
  const session = useSession();

  if (session.status === "loading") {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (session.status === "signedOut") {
    return <Navigate to="/signin" replace />;
  }
  if (!canUseDashboard(session.user)) {
    return <Navigate to="/unauth" />;
  }

  return <Outlet/>;
}

export default RequireAuth
